import React from "react";
import Slider from "./Slider";
// import MarqueeLComList from "./MarqueeLComList";
// import { BackTop } from "antd";
import '../../../App.css'

const HomeComponent = () => {
  return (
    <div className="home-component w-100">
      <Slider />
    </div>
  );
};

export default HomeComponent;
